import React, { Component } from "react";

import Card from "react-bootstrap/Card";

import "./Publication.css";

class Publication extends Component {  
  componentDidMount() {
    if (this.props.first) {
      this.focusedItem.focus();
    }
  }

  render() {
    return (
      <div className="row justify-content-center">
        <Card className="border-dark mx-2 mb-3 " style={this.style}>
          <a
            href={this.props.publication.link}
            target="_blank"
            rel="noopener noreferrer"
            ref={(focus) => {
              if (this.props.first) {
                this.focusedItem = focus;
              }
            }}
          >
            <img
              src={this.props.publication.image}
              alt={this.props.publication.name}
              height="auto"
              width="90%"
            />
          </a>
        </Card>
      </div>
    );
  }
}

export default Publication;
